import { __ } from "@wordpress/i18n";
import { PanelBody, PanelRow, TextControl, TextareaControl } from "@wordpress/components";

import { BControlPro } from "../../../../../../../wp-utils/v1/components/";

const Additional = ({ attributes, setAttributes }) => {
  const { additional, isPremium } = attributes;
  return (
    <>
      <PanelBody title={__("Additional", "b3d-viewer-lite")}>
        <BControlPro isPremium={isPremium} Component={TextControl} label={__("ID", "b3d-viewer-lite")} value={additional.ID} onChange={(ID) => setAttributes({ additional: { ...additional, ID } })} />
        <TextControl label={__("Class", "b3d-viewer-lite")} value={additional.Class} onChange={(Class) => setAttributes({ additional: { ...additional, Class } })} />

        <BControlPro isPremium={isPremium} Component={TextareaControl} label={__("CSS", "b3d-viewer-lite")} value={additional.CSS} onChange={(CSS) => setAttributes({ additional: { ...additional, CSS } })} />
      </PanelBody>
    </>
  );
};

export default Additional;
